import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import Button from '../Elements/Button';

const ErrorPage = () => {
    const err = useRouteError();
    const detail = err?.status
        ? `${err.status}: ${err.statusText}`
        : 'Please try again or contact support if the problem persists.';

    useEffect(() => {
        if (err && !err.status) {
            console.error(err);
        }
    }, [err]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            textAlign: 'center',
            padding: '24px',
        }}>
            <h1>Oops!!!</h1>
            <h2>Something went wrong!!</h2>
            <h3 style={{ color: '#777', fontWeight: 400, marginBottom: '24px' }}>
                {detail}
            </h3>
            <Button
                text="Go to home page"
                classList="success"
                addonClass="my-2"
                onClick={() => { window.location.href = '/'; }}
            />
        </div>
    );
}
export default ErrorPage;